import React from 'react';
import { formatDate, getUniqueRuleSources, localizedValue } from './nationalizationViewModel';

export default function NationalizationRuleSources({ overview, language, t }) {
  const sources = getUniqueRuleSources(overview);

  return (
    <section className="nationalization-support-card nationalization-rule-sources">
      <div className="nationalization-support-card-header">
        <div>
          <h3>{t('rules.title', 'Rules and official sources')}</h3>
          <p>{t('rules.manualUpdates', 'JOBSEEQR rules are reviewed and entered manually before they affect your result.')}</p>
        </div>
        <span>{t('rules.calculationVersion', 'Calculation {{version}}', {
          version: overview?.calculation_version || '—'
        })}</span>
      </div>

      {sources.length ? (
        <div className="nationalization-source-list">
          {sources.map((source, index) => (
            <article key={`${source.ruleId || 'source'}-${index}`}>
              <div>
                <strong>{localizedValue(source, language, 'title') || source.reference || source.ruleId}</strong>
                <p>
                  {t('rules.versionAndEffectiveDate', 'Version {{version}} · Effective {{date}}', {
                    version: source.ruleVersion || '—',
                    date: formatDate(source.effectiveFrom, language)
                  })}
                </p>
              </div>
              {source.url && (
                <a href={source.url} target="_blank" rel="noreferrer">
                  {t('actions.openOfficialSource', 'Open official source')}
                  <i className="fa-solid fa-arrow-up-right-from-square" aria-hidden="true" />
                </a>
              )}
            </article>
          ))}
        </div>
      ) : (
        <p className="nationalization-empty-copy">
          {t('rules.noSources', 'No published rule source is attached to this calculation yet.')}
        </p>
      )}

      <small className="nationalization-generated-at">
        {t('rules.generatedAt', 'Last calculated: {{date}}', {
          date: formatDate(overview?.generated_at, language)
        })}
      </small>
    </section>
  );
}
